import React from "react";
import { useNavigate } from "react-router-dom";
import { Prohibit } from "@phosphor-icons/react";
import { SCREEN_LABELS } from "../lib/api";

export default function AccessDenied({ screen }) {
  const navigate = useNavigate();
  const label = SCREEN_LABELS[screen] || screen;
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100 p-8">
      <div className="max-w-md w-full bg-white border-2 border-red-600">
        <div className="bg-red-600 text-white p-5 flex items-center gap-3">
          <Prohibit size={28} weight="fill" />
          <div>
            <div className="font-mono text-[10px] tracking-[0.3em] opacity-80">ERROR / 403</div>
            <div className="font-display font-black text-xl uppercase tracking-tight">Access Restricted</div>
          </div>
        </div>
        <div className="p-6">
          <p className="text-sm text-zinc-700 leading-relaxed">
            Your role does not have permission to access{" "}
            <span className="font-bold font-mono uppercase">{label}</span>.
            Please contact your administrator to request access.
          </p>
          <button
            data-testid="access-denied-back"
            onClick={() => navigate(-1)}
            className="kr-btn-primary w-full mt-6 py-2.5 text-sm"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
